import { render } from "./BrandGuidelinesUpload.vue?vue&type=template&id=324cbc12"
import script from "./BrandGuidelinesUpload.vue?vue&type=script&lang=js"
export * from "./BrandGuidelinesUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__